<div class="close-btn-mobile" (click)="onClosePopup()">
  <img alt="Close" src="/assets/icons/close-icon.svg">
</div>
<div class="container">
  <h1 class="main-title">{{ contactToDisplay?.FirstName }} {{ contactToDisplay?.LastName }}</h1>
  <h3 class="light-title">{{ contactToDisplay?.ContactTypeText }}</h3>
  <h3 class="info-title" fiTranslation="REQUEST_DETAIL_HEADLINE_CONTACT"></h3>
  @if (contactToDisplay?.Email) {
    <span class="info-line mail">
      <a class="custom-link" href="mailto: {{ contactToDisplay?.Email }}">{{ contactToDisplay?.Email }}</a>
      @if (contactToDisplay?.ContactMethodName === 'E-MAIL') {
        <span class="prefer-contact"
        fiTranslation="REQUEST_DETAIL_HEADLINE_PREFERENCE"></span>
      }
    </span>
  }
  @if (contactPhone) {
    <span class="info-line telephone">
      <a class="custom-link" href="tel: {{ contactPhone }}">{{ contactPhone }}</a>
      @if (contactToDisplay?.ContactMethodName === 'TELEFON') {
        <span class="prefer-contact"
        fiTranslation="REQUEST_DETAIL_HEADLINE_PREFERENCE"></span>
      }
    </span>
  }
  @if (contactMobile) {
    <span class="info-line phone">
      <a class="custom-link" href="tel: {{ contactMobile }}">{{ contactMobile }}</a>
      @if (contactToDisplay?.ContactMethodName === 'MOBILE') {
        <span class="prefer-contact"
        fiTranslation="REQUEST_DETAIL_HEADLINE_PREFERENCE"></span>
      }
    </span>
  }
  @if (contactToDisplay?.LanguageText) {
    <h3 class="info-title" fiTranslation="FORM_HEADLINE_LANGUAGE"></h3>
  }
  @if (contactToDisplay?.LanguageText) {
    <span class="info-line" >{{ contactToDisplay?.LanguageText }}</span>
  }
  <h3 class="info-title" fiTranslation="REQUEST_DETAIL_HEADLINE_ADDRESS"></h3>
  @if (contactToDisplay?.Address) {
    <span class="info-line">{{ contactToDisplay?.Address }}</span>
  }
  @if (contactToDisplay?.ZipCode || contactToDisplay?.City) {
    <span
    class="info-line">{{ contactToDisplay?.ZipCode }} {{ contactToDisplay?.City }}</span>
  }
  @if (contactToDisplay?.CountryText) {
    <span
    class="info-line">{{ contactToDisplay?.CountryText }}</span>
  }
</div>
